import { render, staticRenderFns } from "./KalturaVideo.vue?vue&type=template&id=d49d5164&"
import script from "./KalturaVideo.vue?vue&type=script&lang=ts&"
export * from "./KalturaVideo.vue?vue&type=script&lang=ts&"
import style0 from "./KalturaVideo.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports